import React from 'react'
import { useTranslation } from 'react-i18next'
import { useParams, useRouteMatch } from 'react-router-dom'

import { Col, Row, Skeleton } from 'antd'
//
import global from 'common'

import { EmployeeDetailsResponse, getEmployeeDetails } from 'core/application/companies/getEmployeeDetails'

import EmployeeProfileDetails from 'common/components/employeeProfile/EmployeeProfileDetails'

import useLoginUser from '../../../common/hooks/useLoginUser'

const ViewProfile: React.FC = () => {
  const { t: translate } = useTranslation()
  const { id } = useParams<any>()
  const match = useRouteMatch()
  const [user] = useLoginUser()

  const companyUserId = id ?? user.companyUserId

  const [employeeDetails] = global.hooks.useQueryRequest<EmployeeDetailsResponse>(null, () =>
    getEmployeeDetails(companyUserId),
  )

  return (
    employeeDetails && (
      <Row>
        <Col span={24}>
          <Skeleton active loading={!employeeDetails}>
            <EmployeeProfileDetails
              employeeDetails={employeeDetails}
              editProfileUrl={`${match.path}/edit`}
              profileTitle={translate('employee-profile.my-profile-title')}
            />
          </Skeleton>
        </Col>
      </Row>
    )
  )
}

export default ViewProfile
